import React, { useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";
import { UserContext } from "../../contexts/UserContext";

export default function SendNDA({
  expert_id,
  project_id,
  NDAStatus,
  setNDAStatus,
  in_zoho,
  data
}) {
  const { userData, userError, adminUser, msalAccount, notifications, setNotifications } =
    useContext(UserContext);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const [NDAListPopup, setNDAListPopup] = useState(false);
  const [templateList, setTemplateList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [NDASigned, setNDASigned] = useState(false)
  const { API_URL } = useContext(UrlContext);
  const [error, setError] = useState(false);

  useEffect(() => {
    if(NDAStatus !== "" && NDAStatus !== "inprogress"){
      setNDASigned(true)
    }
  }, [NDAStatus])

  useEffect(() => {
    setNDAStatus(data?.NDArequestStatus);
  }, []);

  const sendNDAHandler = async (templateID, actions) => {
    console.log("Current NDA Status: ", NDAStatus);
    setNDAListPopup(false);
    setLoadingPopup(true);
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    const url = `${API_URL}send-NDA-to-sign`
    const data = {
      expertID: expert_id,
      projectID: project_id,
      templateID: templateID,
      actions: actions,
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();

      if (responseData.status === "success") {
        if (NDAStatus === "" || NDAStatus === null) {
          // setNDAListPopup(true)
          setNDAStatus("inprogress");
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "NDA sent successfully!",
          });
        } else if (NDAStatus === "inprogress") {
          setNDAStatus("recalled");
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "NDA recalled successfully!",
          });
        } else if (NDAStatus === "recalled"){
          setNDAStatus("inprogress");
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "NDA sent successfully!",
          });
        }
      } else if (responseData.status === "error") {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    } catch (error) {
      setLoadingPopup(false);
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
    setLoadingPopup(false);
  };

  const handleNDAClick = async () => {
    if (in_zoho === "yes") {
      setLoadingPopup(true);
      let url = "";
      if (NDAStatus === "" || NDAStatus === "expired" || NDAStatus === "recalled" || NDAStatus === null) {
        url = `${API_URL}get-list-zoho-sign-template`;
      } else if (NDAStatus === "inprogress") {
        url = `${API_URL}recall-NDA`;
      } else if (NDAStatus === "completed") {
        url = `${API_URL}view-signed-NDA`;
      }
      const data = {
        expertID: expert_id,
        projectID: project_id,
      };
      const ephToken = localStorage.getItem("eph-token");
      const token = JSON.parse(ephToken).value;
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
          body: JSON.stringify(data),
        });

        setLoadingPopup(false);

        if (NDAStatus === "completed") {
          setLoadingPopup(false);
          const contentType = response.headers.get('Content-Type');
          const blob = await response.blob();
          if (contentType && contentType.includes('application/pdf')) {
            // Open PDF in a new tab
            const fileURL = URL.createObjectURL(blob);
            window.open(fileURL);
          } else if (contentType && contentType.includes('application/zip')) {
            // Download ZIP file
            // Try to get filename from Content-Disposition header
            let filename = `NDA_${expert_id}.zip`;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
          } else {
            // Handle other content types or errors
            alert('Unknown file type or error occurred.');
          }
        } else {
          const responseData = await response.json();
          if (responseData.status === "success") {
            setLoadingPopup(false);
            if (NDAStatus === "" || NDAStatus === "expired" || NDAStatus === "recalled" || NDAStatus === null) {
              setNDAListPopup(true)
              // setNDAStatus("inprogress");
              setTemplateList(responseData.templateList)
            } else if (NDAStatus === "inprogress") {
              setNDAStatus("recalled");
              setLoadingPopup(false);
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "NDA recalled successfully!",
              });
            }
          } else {
            setLoadingPopup(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: responseData.message,
            });
          }
        }
      } catch (error) {
        setLoadingPopup(false);
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    } else {
      setLoadingPopup(false);
      Swal.fire({
        icon: "info",
        title: "Add Expert to Zoho before Sending NDA!",
        // text: "Add Expert to Zoho before Sending NDA!",
        showConfirmButton: true,
      });
    }
  };
  
  useEffect(() => {
    if (data?.NDArequestID && data?.NDArequestStatus !== "completed") {
      const fetchNDAStatuses = async () => {
        setLoading(true);
        setError(false);
        const url = `${API_URL}fetch-NDA-status/`;
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ projectID: project_id, expertID: expert_id }),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status === "success") {
              setNDAStatus(data.currentNDAStatus);
            } else {
              console.log("Error fetching NDA status!");
              setError(true);
            }
          })
          .catch((err) => {
            console.log(err);
          });
        setLoading(false);
      };
      fetchNDAStatuses();
    } else {
      setNDAStatus(data?.NDArequestStatus);
    }
  }, []);

  return (
    <>
      <button
        className="btn"
        style={{ width: "156px", display: "flex", justifyContent: "center", alignItems: "center" }}
        onClick={() => handleNDAClick()}
      >
        {NDAStatus === "inprogress" ? (
          "Recall NDA"
          ) : NDAStatus === "" || NDAStatus === null ? (
            "Send NDA"
          ) : NDAStatus === "recalled" ? (
            "Recalled"
          ) : NDAStatus === "expired" ? (
            "Expired"
          ) : NDAStatus === "completed" ? (
            <>
              NDA signed
              <i className="fa fa-download" style={{ marginLeft: 8 }} title="Download NDA"></i>
            </>
          ) : (
            "Send NDA"
          )}
        {loading && (
          <>
            <i class="fa-solid fa-spinner fa-spin" style={{color: "#365561", marginLeft: "120px", position: "absolute"}}></i>
          </>
        )}
        {error && (
          <>
            <i class="fa-solid fa-triangle-exclamation" style={{color: "red", marginLeft: "10px"}}></i>
          </>
        )}
      </button>

      {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>Please wait . . .</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}

      {NDAListPopup && (
        <div id="pptExisting-wrapper">
          <div className="tab-pane fade show pptExisting-div position-relative">
            <i
              className="pptlist-close-icon fa-regular fa-rectangle-xmark"
              onClick={() => setNDAListPopup(false)}
            ></i>

            {templateList?.length > 0 && (
              <div className="row" style={{ marginBottom: "10px" }}>
                <div className="col-md-12">
                  <table className="expert-pptExists-table">
                    <thead>
                      <tr>
                        <th style={{ minWidth: "800px", width: "900px" }}>
                          NDA Templates
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {templateList?.map((template) => {
                        if (template.templateName) {
                          return (
                            <tr key={template.templateID}>
                              <td
                                onClick={() =>
                                  sendNDAHandler(template.templateID, template.actions)
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <div className="expert-ppt-existing-row">
                                  {template.templateName}
                                </div>
                              </td>
                            </tr>
                          );
                        } else return null;
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div style={{ marginTop: 20, textAlign: "center" }}>
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setNDAListPopup(false)}
              >
                Cancel
              </button>
              {/* <button
                type="button"
                className="btn base-btn"
                onClick={createNewPPTHandler}
              >
                Create New PPT
              </button> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
